import ApiService from './ApiService';

export default class JournalService {
  static getUserSettings() {
    return ApiService.get('journals/settings');
  }

  static getMembershipStatus() {
    return ApiService.get('journals/memberships');
  }

  static getPublishersPageData(slug) {
    return ApiService.get(`journals/${encodeURIComponent(slug)}/publishers-page-section`);
  }

  static updateUserJournal(journalId) {
    return ApiService.put('journals/user', { user_type: 'publisher-user', journal_id: journalId });
  }
}
